export default __webpack_public_path__ + "static/media/shit-storm.3f36dba0.gif";